var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "34px",
            "line-height": "30px",
            "padding-left": "10px",
            "font-size": "14px",
            "background-color": "#EFEFEF"
          },
          attrs: { name: "confHeader" }
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.title || "结果列设置") + "\n        "
          ),
          !_vm.viewMode
            ? _c(
                "span",
                { staticClass: "ml10" },
                [
                  _vm.userMode == 0
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: { type: "danger", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.clearMetaCols()
                            }
                          }
                        },
                        [_vm._v("清除所有字段")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode == 0
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20 mr20",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.addMetaCol()
                            }
                          }
                        },
                        [_vm._v("+ 追加字段")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode == 0
                    ? _c("el-divider", { attrs: { direction: "vertical" } })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode < 2
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20 mr10",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: {
                            type: "primary",
                            title: "把固定列按未来结果排在最前面",
                            size: "mini"
                          },
                          on: {
                            click: function($event) {
                              _vm.bttopFixedCols()
                            }
                          }
                        },
                        [_vm._v("固定列置于前")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userMode == 2 && !_vm.viewMode
            ? _c(
                "span",
                { staticClass: "fr mr5" },
                [
                  _c(
                    "el-link",
                    {
                      staticClass: "ml20 mr10",
                      staticStyle: {
                        "padding-bottom": "2px",
                        "font-size": "13px"
                      },
                      attrs: {
                        type: "primary",
                        title: "把固定列按未来结果排在最前面",
                        size: "mini"
                      },
                      on: {
                        click: function($event) {
                          _vm.bttopFixedCols()
                        }
                      }
                    },
                    [_vm._v("固定列置于前")]
                  ),
                  _vm._v(" "),
                  _vm.showExtBtns
                    ? _c(
                        "span",
                        { staticClass: "ml30 mr5" },
                        [
                          _vm.custSavable && _vm.onSaveCustConf != null
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-top": "1px" },
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-document-checked",
                                    title: "保存个性调整"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.handleSaveCustConf()
                                    }
                                  }
                                },
                                [_vm._v("保存调整")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.custSavable && _vm.onSaveCustConf != null
                            ? _c("el-divider", {
                                attrs: { direction: "vertical" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-top": "1px" },
                              attrs: {
                                size: "mini",
                                icon: "el-icon-check",
                                title: "应用列调整"
                              },
                              on: {
                                click: function($event) {
                                  _vm.handleConfirm()
                                }
                              }
                            },
                            [_vm._v("应用")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "ml20",
                              staticStyle: {
                                width: "30px",
                                height: "30px",
                                "text-align": "center",
                                "vertical-align": "middle"
                              },
                              attrs: { title: "取消/关闭" },
                              on: {
                                click: function($event) {
                                  _vm.handleClose()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-close",
                                staticStyle: { "font-size": "18px" }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userMode < 2 && !_vm.viewMode
            ? _c(
                "span",
                { staticClass: "fr mr5" },
                [
                  _vm.userMode == 0
                    ? _c(
                        "span",
                        [
                          _c("el-input", {
                            staticClass: "mr10",
                            staticStyle: { width: "100px" },
                            attrs: {
                              size: "mini",
                              placeholder: "输入 过滤文本",
                              clearable: ""
                            },
                            on: { change: _vm.filterList },
                            model: {
                              value: _vm.instantKeyword,
                              callback: function($$v) {
                                _vm.instantKeyword = $$v
                              },
                              expression: "instantKeyword"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-divider", {
                            attrs: { direction: "vertical" }
                          }),
                          _vm._v(" "),
                          _vm.forHisQry
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "el-link",
                                    {
                                      staticClass: "ml10 mr10",
                                      staticStyle: {
                                        "padding-bottom": "2px",
                                        "font-size": "13px"
                                      },
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        icon: "el-icon-notebook-2"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.appendFromCols()
                                        }
                                      }
                                    },
                                    [_vm._v("从表列选择")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-divider", {
                                    attrs: { direction: "vertical" }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-link",
                            {
                              staticClass: "ml10 mr10",
                              staticStyle: {
                                "padding-bottom": "2px",
                                "font-size": "13px"
                              },
                              attrs: {
                                type: "primary",
                                size: "mini",
                                icon: "el-icon-document",
                                title: "meta colList"
                              },
                              on: {
                                click: function($event) {
                                  _vm.inputJsonConf()
                                }
                              }
                            },
                            [_vm._v("输入json配置")]
                          ),
                          _vm._v(" "),
                          _vm.onPreviewConf != null
                            ? _c("el-divider", {
                                attrs: { direction: "vertical" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode < 2 && _vm.onPreviewConf != null
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml10 mr10",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: {
                            type: "primary",
                            size: "mini",
                            icon: "el-icon-view"
                          },
                          on: {
                            click: function($event) {
                              _vm.previewTheConf()
                            }
                          }
                        },
                        [_vm._v("预览当前配置")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        {
          ref: "dynaTagPopover",
          attrs: { disabled: _vm.userMode != 0 },
          on: {
            show: function($event) {
              _vm.syncDynaTagEditorVisible(true)
            },
            hide: function($event) {
              _vm.syncDynaTagEditorVisible(false)
            }
          },
          model: {
            value: _vm.dynaTagEditorVisible,
            callback: function($$v) {
              _vm.dynaTagEditorVisible = $$v
            },
            expression: "dynaTagEditorVisible"
          }
        },
        [
          _c("swb-prop-editor", {
            attrs: {
              title: _vm.dynaTagEditor.title,
              showBtnBar: _vm.dynaTagEditor.showBtnBar,
              width: _vm.dynaTagEditor.width,
              widthForLabel: _vm.dynaTagEditor.widthForLabel,
              propList: _vm.dynaTagEditor.propList,
              extra: _vm.dynaTagEditor.extra,
              viewMode: _vm.dynaTagEditor.viewMode,
              readOnly: _vm.dynaTagEditor.readOnly,
              onConfirm: _vm.onDynaTagEditorConfirm,
              onCancel: _vm.onDynaTagEditorCancel
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        {
          ref: "colTipPopover",
          attrs: { title: "列头提示信息", disabled: _vm.userMode > 1 }
        },
        [
          _c(
            "div",
            [
              _c("el-input", {
                staticStyle: { width: "400px" },
                attrs: {
                  type: "textarea",
                  maxlength: _vm.colTipMaxLength,
                  autosize: _vm.colTipAutoSize
                },
                model: {
                  value: _vm.curColTooltip,
                  callback: function($$v) {
                    _vm.curColTooltip = $$v
                  },
                  expression: "curColTooltip"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    height: "50px",
                    padding: "14px 4px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "130px" },
                      on: {
                        click: function($event) {
                          _vm.doColTipCancel()
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "30px" },
                      on: {
                        click: function($event) {
                          _vm.doColTipConfirm()
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        {
          ref: "enumMapPopover",
          attrs: { title: "列值枚举信息", disabled: _vm.userMode > 0 }
        },
        [
          _c(
            "div",
            [
              _c("el-input", {
                staticStyle: { width: "360px" },
                attrs: {
                  type: "text",
                  placeholder: "格式：name, type，比如 assetNature, value2text",
                  clearable: "",
                  maxlength: 60
                },
                model: {
                  value: _vm.curEnumMap,
                  callback: function($$v) {
                    _vm.curEnumMap = $$v
                  },
                  expression: "curEnumMap"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    height: "50px",
                    padding: "14px 4px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "130px" },
                      on: {
                        click: function($event) {
                          _vm.doEnumMapCancel()
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "30px" },
                      on: {
                        click: function($event) {
                          _vm.doEnumMapConfirm()
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "tableForm",
          staticClass: "result-col-form",
          attrs: { name: "confForm", model: _vm.formData }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "row-draggable",
                  rawName: "v-row-draggable",
                  value: _vm.makeDragCtxData(),
                  expression: "makeDragCtxData()"
                }
              ],
              ref: "gridTable",
              staticStyle: { width: "100%", "min-width": "560px" },
              attrs: {
                data: _vm.formData.colConfRows,
                "row-class-name": _vm.getTableRowClassName,
                "row-key": _vm.rowItemKey,
                stripe: "",
                "highlight-current-row": "",
                size: "mini",
                height: _vm.gridHeight
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  fixed: ""
                }
              }),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "名称/代码", width: "120", fixed: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop: "colConfRows[" + scope.$index + "].name"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "col-name",
                                  attrs: { maxlength: "30", size: "mini" },
                                  model: {
                                    value: scope.row.name,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "默认标题", width: "100", fixed: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "text" },
                          [
                            _vm.userMode == 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      prop:
                                        "colConfRows[" + scope.$index + "].text"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "col-text",
                                      attrs: { maxlength: "20", size: "mini" },
                                      model: {
                                        value: scope.row.text,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "text", $$v)
                                        },
                                        expression: "scope.row.text"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.userMode == 1
                              ? _c("div", [_vm._v(_vm._s(scope.row.text))])
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.metaTitle || scope.row.text
                                    )
                                  )
                                ])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userMode > 0
                ? _c("el-table-column", {
                    attrs: { label: "自定义标题", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                    自定义标题\n                    "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            - 自定义标题如果与默认标题不同，则会显示绿色下划线"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            - 注意：对于 隐藏列 无效\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "col-title-tooltip-wrapper" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-question col-title-tooltip"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "colConfRows[" + scope.$index + "].title"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "col-title",
                                  class: {
                                    diff: _vm.isDiffTitle(scope.$index)
                                  },
                                  attrs: {
                                    maxlength: "20",
                                    size: "mini",
                                    clearable: "",
                                    disabled:
                                      scope.row.hidden || scope.row.dynaTag
                                  },
                                  model: {
                                    value: scope.row.title,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "title", $$v)
                                    },
                                    expression: "scope.row.title"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "合并组标题", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n                    合并组标题\n                    "
                        ),
                        _vm.userMode == 2
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "line-height": "30px" },
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            - 未输入文字时的默认灰色文字为预设的合并组标题 "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            - 如果自定义的合并组标题与预设的不同，则会显示绿色下划线"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            - 提示：可以敲入英文空格让默认合并组标题失效（也即不分组）"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                            - 注意：对于 隐藏列 和 固定列 无效\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "col-title-tooltip-wrapper" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-question col-title-tooltip"
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "colConfRows[" + scope.$index + "].group"
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: scope.row.group,
                                  expression: "scope.row.group"
                                }
                              ],
                              staticClass: "col-group",
                              class: { diff: _vm.isDiffGroup(scope.$index) },
                              staticStyle: {
                                height: "28px",
                                "font-size": "12px",
                                width: "90px"
                              },
                              attrs: {
                                maxlength: "20",
                                type: "text",
                                placeholder:
                                  scope.row.fixed || scope.row.hidden
                                    ? ""
                                    : scope.row.metaGroup,
                                size: "mini",
                                clearable: "",
                                disabled: scope.row.fixed || scope.row.hidden
                              },
                              domProps: { value: scope.row.group },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    scope.row,
                                    "group",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "像素宽",
                  width: "60",
                  "header-align": "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "colConfRows[" + scope.$index + "].width",
                              title: _vm.getColWidthHint()
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "col-width",
                              attrs: {
                                maxlength: "10",
                                size: "mini",
                                placeholder: "",
                                disabled: scope.row.hidden
                              },
                              on: {
                                blur: function($event) {
                                  _vm.filterColWidth(scope.row, scope.$index)
                                }
                              },
                              model: {
                                value: scope.row.width,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "width", $$v)
                                },
                                expression: "scope.row.width"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "数据类型",
                  width: "100",
                  align: "center",
                  "header-align": "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.userMode == 0
                          ? _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "colConfRows[" + scope.$index + "].dataType"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "col-dataType",
                                    attrs: { size: "mini" },
                                    model: {
                                      value: scope.row.dataType,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "dataType", $$v)
                                      },
                                      expression: "scope.row.dataType"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: "字符串",
                                        value: "string"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "整  数",
                                        value: "integer"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "浮点数", value: "float" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "日期/时间",
                                        value: "date"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "布尔/是否",
                                        value: "bool"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(_vm.getDataTypeName(scope.row.dataType))
                              )
                            ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "水平对齐", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "colConfRows[" + scope.$index + "].align"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  size: "mini",
                                  disabled: scope.row.hidden
                                },
                                model: {
                                  value: scope.row.align,
                                  callback: function($$v) {
                                    _vm.$set(scope.row, "align", $$v)
                                  },
                                  expression: "scope.row.align"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "|<---", value: "left" }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "->|<-", value: "center" }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "---->|", value: "right" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: {
                      label: "格式化模式",
                      width: "160",
                      "header-align": "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.isFormattable(scope.row.dataType)
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      prop:
                                        "colConfRows[" +
                                        scope.$index +
                                        "].format"
                                    }
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: scope.row.format,
                                          expression: "scope.row.format"
                                        }
                                      ],
                                      staticClass: "col-format",
                                      staticStyle: {
                                        height: "28px",
                                        "font-size": "12px",
                                        width: "150px"
                                      },
                                      attrs: {
                                        maxlength: "20",
                                        type: "text",
                                        disabled: scope.row.hidden
                                      },
                                      domProps: { value: scope.row.format },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            scope.row,
                                            "format",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              : _c("div")
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "枚举", width: "50", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: scope.row.dataType == "integer",
                                    expression:
                                      "scope.row.dataType == 'integer'"
                                  }
                                ],
                                attrs: { title: scope.row.enumMap },
                                on: {
                                  click: function($event) {
                                    _vm.showEnumMapEditor($event, scope.$index)
                                  }
                                }
                              },
                              [
                                scope.row.enumMap
                                  ? _c("i", {
                                      staticClass: "el-icon-document",
                                      staticStyle: {
                                        "font-size": "16px",
                                        "border-bottom": "1px dashed darkblue"
                                      }
                                    })
                                  : _c("i", {
                                      staticClass: "el-icon-document",
                                      staticStyle: { "font-size": "16px" }
                                    })
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode < 2
                ? _c("el-table-column", {
                    attrs: { width: "40", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { "white-space": "pre-wrap" },
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [_vm._v("设置列头提示说明信息")]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-question col-title-tooltip"
                                  })
                                ])
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { title: scope.row.tooltip },
                                on: {
                                  click: function($event) {
                                    _vm.showColTipEditor($event, scope.$index)
                                  }
                                }
                              },
                              [
                                scope.row.tooltip
                                  ? _c("i", {
                                      staticClass: "el-icon-chat-line-square",
                                      staticStyle: {
                                        "font-size": "16px",
                                        "border-bottom": "1px dashed darkblue"
                                      }
                                    })
                                  : _c("i", {
                                      staticClass: "el-icon-chat-line-square",
                                      staticStyle: { "font-size": "16px" }
                                    })
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "超宽...", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.overflowAsTip,
                              expression: "scope.row.overflowAsTip"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: scope.row.hidden
                          },
                          domProps: {
                            checked: Array.isArray(scope.row.overflowAsTip)
                              ? _vm._i(scope.row.overflowAsTip, null) > -1
                              : scope.row.overflowAsTip
                          },
                          on: {
                            change: function($event) {
                              var $$a = scope.row.overflowAsTip,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      scope.row,
                                      "overflowAsTip",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      scope.row,
                                      "overflowAsTip",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(scope.row, "overflowAsTip", $$c)
                              }
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "固定列", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.fixed,
                              expression: "scope.row.fixed"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: scope.row.hidden
                          },
                          domProps: {
                            checked: Array.isArray(scope.row.fixed)
                              ? _vm._i(scope.row.fixed, null) > -1
                              : scope.row.fixed
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = scope.row.fixed,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        scope.row,
                                        "fixed",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        scope.row,
                                        "fixed",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(scope.row, "fixed", $$c)
                                }
                              },
                              function($event) {
                                _vm.syncFixedColConf(scope.row, scope.$index)
                              }
                            ]
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "隐藏之", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.hidden,
                              expression: "scope.row.hidden"
                            }
                          ],
                          attrs: {
                            type: "checkbox",
                            disabled: scope.row.secret
                          },
                          domProps: {
                            checked: Array.isArray(scope.row.hidden)
                              ? _vm._i(scope.row.hidden, null) > -1
                              : scope.row.hidden
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = scope.row.hidden,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        scope.row,
                                        "hidden",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        scope.row,
                                        "hidden",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(scope.row, "hidden", $$c)
                                }
                              },
                              function($event) {
                                _vm.syncHiddenColConf(scope.row, scope.$index)
                              }
                            ]
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "报表用", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: scope.row.rptUsed,
                                  expression: "scope.row.rptUsed"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(scope.row.rptUsed)
                                  ? _vm._i(scope.row.rptUsed, null) > -1
                                  : scope.row.rptUsed
                              },
                              on: {
                                change: function($event) {
                                  var $$a = scope.row.rptUsed,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          scope.row,
                                          "rptUsed",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          scope.row,
                                          "rptUsed",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(scope.row, "rptUsed", $$c)
                                  }
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "动态标签", width: "70", align: "left" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.mayBeDynaTagField(
                                      scope.row,
                                      scope.$index
                                    ),
                                    expression:
                                      "mayBeDynaTagField(scope.row, scope.$index)"
                                  }
                                ]
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: scope.row.dynaTag,
                                      expression: "scope.row.dynaTag"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(scope.row.dynaTag)
                                      ? _vm._i(scope.row.dynaTag, null) > -1
                                      : scope.row.dynaTag
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = scope.row.dynaTag,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              scope.row,
                                              "dynaTag",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              scope.row,
                                              "dynaTag",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(scope.row, "dynaTag", $$c)
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-link",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: scope.row.dynaTag,
                                        expression: "scope.row.dynaTag"
                                      }
                                    ],
                                    staticStyle: {
                                      cursor: "pointer",
                                      "margin-left": "8px"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showDynaTagEditor(
                                          $event,
                                          scope.$index
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-setting",
                                      attrs: {
                                        title: "设置动态标签字段配置信息"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.viewMode
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作/顺序",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-arrow-top pr10",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.moveColPosition(
                                      scope.row.name,
                                      scope.$index,
                                      "prev"
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-arrow-bottom pr10",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.moveColPosition(
                                      scope.row.name,
                                      scope.$index,
                                      "next"
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.userMode == 0
                                ? _c("i", {
                                    staticClass:
                                      "icon iconfont el-icon-delete pl10 pr10",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "orange"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.deleteMetaCol(scope.$index)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode == 0 && _vm.showAsTpl
                ? _c("el-table-column", {
                    attrs: { width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  placement: "top",
                                  "open-delay": _vm.tooltipDelayMs
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content"
                                  },
                                  [
                                    _vm._v(
                                      "是否把返回的自定义列内容当作vue模板"
                                    ),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(
                                      "以便按类似<template>...</template>的方式渲染结果单元格内容"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("按模板")])
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: scope.row.asTpl,
                                  expression: "scope.row.asTpl"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled: scope.row.hidden
                              },
                              domProps: {
                                checked: Array.isArray(scope.row.asTpl)
                                  ? _vm._i(scope.row.asTpl, null) > -1
                                  : scope.row.asTpl
                              },
                              on: {
                                change: function($event) {
                                  var $$a = scope.row.asTpl,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          scope.row,
                                          "asTpl",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          scope.row,
                                          "asTpl",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(scope.row, "asTpl", $$c)
                                  }
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userMode < 2
                ? _c("el-table-column", {
                    attrs: { label: "私密的", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: scope.row.secret,
                                  expression: "scope.row.secret"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(scope.row.secret)
                                  ? _vm._i(scope.row.secret, null) > -1
                                  : scope.row.secret
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = scope.row.secret,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            scope.row,
                                            "secret",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            scope.row,
                                            "secret",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(scope.row, "secret", $$c)
                                    }
                                  },
                                  function($event) {
                                    _vm.syncSecretColConf(
                                      scope.row,
                                      scope.$index
                                    )
                                  }
                                ]
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dff75fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dff75fe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/ResultColConf.vue
// module id = 2158
// module chunks = 0